module.exports = __webpack_public_path__ + "static/media/rm1.73a2c3a3.jpg";